module.exports = __webpack_public_path__ + "static/spiria-e274bc30655aeae7028476b56fb6fe92.png";